define("shared/helpers/format-number-with-suffix", ["exports", "@ember/component/helper", "later/utils/number-helpers"], function (_exports, _helper, _numberHelpers) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"later/utils/number-helpers"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /**
   * @class formatNumberWithSuffix
   * @extends Helpers
   */
  /**
   * Converts count to use metric suffix symbols.
   *
   * If you are getting an error in here, you might
   * be passing in a string representation of a number.
   *
   * Using unary plus here to convert to number
   * see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Arithmetic_Operators#Unary_plus_()
   *
   * @method formatNumberWithSuffix
   * @param {Number} count Number to be formatted
   * @param {Number} defaultValue (Optional) What to return if number does not exist
   * @param {Number} roundTo (Optional) Number of decimal places to round to for a count between 10,000-1,000,000
   *
   * @return {String} Converted value that uses metric symbol presentation
   */
  var _default = _exports.default = (0, _helper.helper)(_ref => {
    let [number, defaultValue, roundTo] = _ref;
    return (0, _numberHelpers.formatNumberWithSuffix)(number, defaultValue, roundTo);
  });
});